<template>
  <div class="pdf-thumb-box">
    <canvas ref="pdfCanvas" ></canvas>
  </div>
</template>

<script>
export default {
  props: {
    pdfUrl: String,
    scale: {
      type: Number,
      default: 0.5
    }
  },
  data() {
    return {
    }
  },
  mounted() {
  },
  watch: {
    pdfUrl: {
      handler(newVal, oldVal) {
        console.log(newVal)
        if (newVal !== oldVal) {
          this.renderFirstPage()
        }
      },
      immediate: true
    }
  },
  methods: {
    async renderFirstPage() {
        const pdfjsLib = window.pdfjsLib
          pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/build/pdf.worker.min.js'
          try {
            // getDocument 增加字体配置
            const loadingTask = pdfjsLib.getDocument({
              url: this.pdfUrl,
              cMapUrl: 'https://cdn.jsdelivr.net/npm/pdfjs-dist@2.16.105/cmaps/',
              cMapPacked: true
            })
            const pdfDoc = await loadingTask.promise
            const page = await pdfDoc.getPage(1)
            const viewport = page.getViewport({ scale: this.scale })
            const canvas = this.$refs.pdfCanvas
            const ctx = canvas.getContext('2d')
            canvas.width = viewport.width
            canvas.height = viewport.height

            // intent: 'print' 发票渲染模式，文字更稳
            await page.render({
              canvasContext: ctx,
              viewport: viewport,
              intent: 'print'
            }).promise
          } catch (err) {
            console.error('PDF缩略图失败', err)
          }
    }
  }
}
</script>
  